import React from 'react'
import SidebarInf03 from '../../components/sidebar/SidebarInf03'
import xamplaunch from '../../../../../../Assets/egzamininf03/sidebarhelps/launchxampp.jpg'
import createnewdbxampp from '../../../../../../Assets/egzamininf03/sidebarhelps/createnewdbxampp.jpg'
import xamppimport1 from '../../../../../../Assets/egzamininf03/sidebarhelps/xamppimport1.jpg'
import xamppimport2 from '../../../../../../Assets/egzamininf03/sidebarhelps/xamppimport2.jpg'
import xamppimport3 from '../../../../../../Assets/egzamininf03/sidebarhelps/xamppimport3.jpg'
import xamppimport4 from '../../../../../../Assets/egzamininf03/sidebarhelps/xamppimport4.jpg'

const Twimbazyxamp = () => {
  return (
    <div id='rozwiazaniainf03'>

    <SidebarInf03></SidebarInf03>

        <div id="rozwiazanieustawienie">
          <div id="rozwiazanie" style={{ padding: '20px', maxWidth: '900px', margin: 'auto', textAlign: "left" }}>
            <h1>Tworzonie i Importowanie Bazy w XAMPP</h1>
            <hr></hr>
            <section>
              <h2>Wprowadzenie</h2>
              <blockquote class="introduction">
                <strong>Zanim zaczniemy...</strong>
                XAMPP to popularne oprogramowanie, które łączy w sobie serwer Apache, bazę danych MySQL (obecnie MariaDB), 
                język PHP i Perl. Jest to kompletne środowisko serwera webowego, idealne do lokalnego rozwoju aplikacji webowych. 
                W tym artykule omówimy, jak tworzyć i importować bazę danych w XAMPP, używając narzędzia phpMyAdmin.
              </blockquote>
            </section>
            <section>
            <h2>Krok 1: Instalacja i Uruchomienie XAMPP</h2>
              <ol className='listamargin'>
                  <li><strong>Pobranie XAMPP</strong>: Pobierz XAMPP z <a href="https://www.apachefriends.org/index.html" rel="noreferrer" target="_blank">oficjalnej strony Apache Friends</a>.</li>
                  <li><strong>Instalacja XAMPP</strong>: Uruchom pobrany plik instalacyjny i postępuj zgodnie z instrukcjami na ekranie.</li>
                  <li><strong>Uruchomienie XAMPP</strong>: Po zainstalowaniu, uruchom XAMPP Control Panel i uruchom serwery Apache i MySQL, klikając przyciski "Start" obok każdej usługi.</li>
              </ol>
              <img className='obraznr1' src={xamplaunch} alt="Obrazek uruchumiający usługi"></img>
            </section>
            <hr></hr>
            <section>
            <h2>Krok 2: Tworzenie Bazy Danych</h2>
            <ol className='listamargin'>
                <li><strong>Dostęp do phpMyAdmin</strong>: Otwórz przeglądarkę i przejdź do <a href="http://localhost/phpmyadmin" target="_blank">http://localhost/phpmyadmin</a>. phpMyAdmin to graficzny interfejs użytkownika, który pozwala na zarządzanie bazami danych MySQL.</li>
                <li><strong>Tworzenie nowej bazy danych</strong>:
                    <ul>
                        <li>Kliknij zakładkę "Databases" na górnym pasku nawigacyjnym.</li>
                        <li>W polu "Create database" wpisz nazwę nowej bazy danych, np. <code>mydatabase</code> albo tak jak pisze na arkuszu.</li>
                        <li>Kliknij przycisk "Create".</li>
                    </ul>
                </li>
            </ol>
            <img className='obraznr1' src={createnewdbxampp} alt="Obrazek uruchumiający usługi"></img>
            
            </section>
            <hr></hr>
            <section>
            <h2>Krok 3: Importowanie Bazy Danych</h2>
            <ol>
                <li><strong>Tworzenie nowej bazy danych</strong>: Upewnij się, że masz bazę danych, do której chcesz zaimportować dane. Jeśli nie, utwórz ją tak jak w kroku 2.</li>
                <li><strong>Import</strong>:
                    <ul>
                        <li>Wybierz bazę danych w lewym panelu phpMyAdmin.</li>
                        <li>Kliknij zakładkę "Import" na górnym pasku nawigacyjnym.</li>
                        <li>Kliknij "Wybierz Plik" i wybierz plik SQL, który chcesz zaimportować.</li>
                        <li>Kliknij przycisk "Import" na samym dole strony, aby zaimportować dane.</li>
                    </ul>
                </li>
            </ol>
            <img className='obraznr1' src={xamppimport1} alt="Obrazek uruchumiający usługi"></img>
            <img className='obraznr1' src={xamppimport2} alt="Obrazek uruchumiający usługi"></img>
            <img className='obraznr1' src={xamppimport3} alt="Obrazek uruchumiający usługi"></img>
            <img className='obraznr1' src={xamppimport4} alt="Obrazek uruchumiający usługi"></img>
            </section>
            <hr></hr>
            <section>
            <h2>Krok 4: Podsumowanie</h2>
            
            <blockquote className="danger">
                <strong>UWAGA</strong>
                Po zakończeniu importu, sprawdź, czy wszystkie dane zostały poprawnie zaimportowane, przeglądając tabele w wybranej bazie danych.
            </blockquote>
            <p>To tyle! Teraz wiesz, jak tworzyć i importować bazy danych w XAMPP. Mam nadzieję, że ten artykuł był pomocny i ułatwi Ci pracę z bazami danych na egzaminie, a może nawet w Twoich projektach webowych.</p>
            </section>
          </div>
        </div>
    </div>
  )
}

export default Twimbazyxamp